import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const priceMessages = defineMessages({
  required: {
    id: 'ancillaries.settings.insurance.form.name.required',
    defaultMessage: 'The price is required'
  }
})

const salesChannelMessages = defineMessages({
  required: {
    id: 'ancillaries.settings.insurance.form.salesChannel.required',
    defaultMessage: 'You need to select at least one sales channel'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    price: yup.string().required(intl.formatMessage(priceMessages.required)),
    salesChannels: yup.array().min(1, intl.formatMessage(salesChannelMessages.required))
  })
}
